import { InputRule } from '@milkdown/kit/prose/inputrules';
import { $inputRule } from '@milkdown/kit/utils';
import { replace } from 'out-of-character';

import { embedNode } from '../embed';
import { WISTIA_INPUT_REGEX } from '../providers/wistia';

/**
 * Input rule: pasting/typing a Wistia URL creates an embed block
 */
export const wistiaInputRule = $inputRule(
  (ctx) =>
    new InputRule(WISTIA_INPUT_REGEX, (state, match, start, end) => {
      const [rawUrl] = match;
      if (!rawUrl) return null;

      // Clean invisible chars before storing in node
      const url = replace(rawUrl);
      const { tr } = state;

      tr.replaceWith(start, end, embedNode.type(ctx).create({ href: url, embedType: 'wistia' }));

      return tr;
    }),
);
